import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import Request from '../../../shared/request/Request';
import { validatePassword } from '../../../shared/helpers/utils.helper';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import { API } from '../../../shared/constants/API';
import { isValidEmail } from '../../../shared/helpers/utils.helper';
import { HttpStatusCode } from '../../../shared/request/HttpStatusCode';
import { Link } from 'react-router-dom';

const UserNewPassword = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const email: string | null = queryParams.get('email');

  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordsDoNotMatch, setPasswordsDoNotMatch] = useState(false);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;
    const isFormValid = form.checkValidity();

    validatePassword(password, setPasswordValid);

    const doPasswordsMatch = password === confirmPassword;
    setPasswordsDoNotMatch(!doPasswordsMatch);

    if (email && isValidEmail(email) && isFormValid && passwordValid && doPasswordsMatch) {
      Request.put(`${API.USERS_SERVICE}/resetPassword`, {
        body: { email: email, password: password }
      })
        .then((result: any) => {
          if (result.status.toString() === HttpStatusCode.NOT_FOUND) {
            ToasterHelper.notify(t('ERRORS.USER_NOT_FOUND'), 'error');
          } else if (result.status.toString() === HttpStatusCode.OK) {
            ToasterHelper.notify(t('SIGN_IN.PASSWORD_UPDATED'), 'success');
          } else {
            ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    }
  };

  return (
    <div className='mt-10'>
      <p className='text-center text-sm'>
        <b>{t('SIGN_IN.FORGOT_PASSWORD')}</b>
      </p>
      <ToastContainer />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <div className='flex flex-col items-center'>
          <div className='flex flex-col items-center col-md-4 text-sm'>
            <div className='col-md-6'>{t('SIGN_IN.PASSWORD') + ' *'}</div>
            <div className='col-md-6'>
              <Form.Group className='mb-6' controlId='password'>
                <Form.Control
                  type='password'
                  required
                  onChange={handlePasswordChange}
                  value={password}
                  placeholder={t('SIGN_IN.PASSWORD') + ' *'}
                />
                <div>
                  <small className='text-sm text-grey' dangerouslySetInnerHTML={{ __html: t('COMMON.PASSWORD_RULES') }} />
                </div>
                <div>{!passwordValid && <small className='text-danger'>{t('SIGN_IN.VALIDATIONS.PASSWORD_REQUIRED')}</small>}</div>
              </Form.Group>
            </div>
            <div className='col-md-6 mt-3'>{t('SIGN_IN.CONFIRM_PASSWORD') + ' *'}</div>
            <div className='col-md-6'>
              <Form.Group className='mb-6' controlId='confirmPassword'>
                <Form.Control
                  type='password'
                  required
                  onChange={handleConfirmPasswordChange}
                  value={confirmPassword}
                  placeholder={t('SIGN_IN.CONFIRM_PASSWORD') + ' *'}
                />
                <div>{passwordsDoNotMatch && <small className='text-danger'>{t('SIGN_IN.VALIDATIONS.PASSWORD_DO_NOT_MATCH')}</small>}</div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className='text-center mt-2'>
          <Button className='button-font-size background button-border-radius cursor-pointer' variant='primary' type='submit'>
            <b>{t('COMMON.SUBMIT')}</b>
          </Button>
        </div>
      </Form>
      <div className='text-center mt-2'>
        <Link to='/user/signin'>
          <b>{t('SIGN_IN.TITLE')}</b>
        </Link>
      </div>
    </div>
  );
};

export default UserNewPassword;
